import { WorldpayCustomisationBorder } from './worldpay-customisation-border.interface';
import { WorldpayCustomisationInteraction } from './worldpay-customisation-interaction.interface';

export interface WorldpayCustomisationButtons {
  backgroundColor?: string;
  border?: WorldpayCustomisationBorder;
  color?: string;
  focus?: WorldpayCustomisationInteraction;
  fonts?: string[];
  hover?: WorldpayCustomisationInteraction;
}
